import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { stat } from 'fs'
import { MCBPS050QueryRequest } from 'types/MCBPS050/MCBPS050QueryRequest'
import { MCBPS050UploadErrorInfoResultDto } from 'types/MCBPS050/MCBPS050UploadErrorInfoResultDto'

interface InitialDate {
  uploadErrorInfoResult: MCBPS050UploadErrorInfoResultDto
}

const initialState: InitialDate = {
  uploadErrorInfoResult: {
    executionTime: '',
    executor: '',
    selectionFileName: '',
    uploadFileName: '',
    uploadCount: '',
    errorCount: '',
    errorContentsInfo: []
  }
}

const selectionFileUploadErrorConfirmReducer = createSlice({
  name: 'selectionFileUploadErrorConfirm',
  initialState,
  reducers: {
    errorConfirmInit(state, action: PayloadAction<MCBPS050QueryRequest>) {
      return state
    },
    setErrorConfirmInitResult(state, action: PayloadAction<MCBPS050UploadErrorInfoResultDto>) {
      state.uploadErrorInfoResult = action.payload
    }
  }
})

export const {
  errorConfirmInit,
  setErrorConfirmInitResult
} = selectionFileUploadErrorConfirmReducer.actions

export default selectionFileUploadErrorConfirmReducer.reducer